var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play"},[_c('TransitionGroup',{attrs:{"name":"fade","appear":""}},[_c('h2',{key:1},[_vm._v(_vm._s(_vm.translate('play')))]),_c('p',{key:2,staticClass:"subtitle"},[_vm._v(_vm._s(_vm.translate('play.subtitle')))])]),_c('Quizzes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }